import styled from 'styled-components'
import { ButtonMui } from 'src/components/ButtonMui'
import TextFieldMui from 'src/components/TextFieldMui'

const flexCenter = `
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

export const Container = styled.div`
  ${flexCenter}
  padding: .6rem 0;
  justify-content: space-between;
  flex-grow: 1;
`

export const Form = styled.form`
  ${flexCenter}
  gap: .6rem;
  padding: 0 1.4rem;
`

export const FormInputs = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: .6rem;
`

export const ContainerButton = styled.div`
  ${flexCenter}
  padding: 0 1.4rem 1.4rem;
  gap: .6rem;
`

export const CustomButton = styled(ButtonMui)`
  width: 100%;    
  height: 2.8rem !important;
  margin: 0 !important;
`

export const CustomInputText = styled(TextFieldMui)`
  height: 2.5rem !important;
  margin: 0 !important;
  width: 50%;
`

export const ContainerQuantityInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`

export const ContainerRows = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 27.2vh;
  overflow-y: auto;
`

export const Row = styled.div`
  display: flex;
  border-bottom: 1px solid #e0e0e0;
  padding-left: .2rem;
  padding-right: .2rem;
  padding-top: .1rem;
  padding-bottom: .1rem;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 33%;
`
